'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.number = undefined;

var _number = require('./lib/number');

/*
 * Checks for a 'Number'
 * @param number
 * @return boolean
 */
var isNumber = function isNumber(number) {
  return (0, _number._isNumber)(number);
};

/*
 * Validates that 'number' is less than or equal to (<=) the value
 * @param maxValue
 * @return boolean
 */
var maxNumber = function maxNumber() {
  var maxValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.MAX_VALUE;
  return function (value) {
    return (0, _number._isNumber)(value) && value <= maxValue;
  };
};

/*
 * Validates that 'number' is greater than or equal to (>=) the value
 * @param minValue
 * @return boolean
 */
var minNumber = function minNumber() {
  var minValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.MIN_VALUE;
  return function (value) {
    return (0, _number._isNumber)(value) && value >= minValue;
  };
};

/*
 * Validates if number is within the range
 * @param minValue
 * @param maxValue
 * @return boolean
 */
var between = function between() {
  var minValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.MIN_VALUE;
  var maxValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
  return function (value) {
    return minNumber(minValue)(value) && maxNumber(maxValue)(value);
  };
};

/*
 * Export constant number
 */
var number = exports.number = {
  maxNumber: maxNumber,
  minNumber: minNumber,
  between: between,
  isNumber: isNumber
};